export default function getPath(url?: string): Record<string, any> {
    return new URL(url ?? window.location.href);
}
